"use strict";

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _selectors = require("./redux/selectors");

var _actions = require("./redux/actions");

var _utils = require("../../utils");

var _Group = _interopRequireDefault(require("./Group"));

var _ExportHTMLModal = _interopRequireDefault(require("../common/ExportHTMLModal"));

require("../common/component.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ChiaraBannersBuilder = function ChiaraBannersBuilder(_ref) {
  var _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
      _ref$exportedHTML = _ref.exportedHTML,
      exportedHTML = _ref$exportedHTML === void 0 ? '' : _ref$exportedHTML,
      groups = _ref.groups,
      exportCode = _ref.exportCode,
      updateState = _ref.updateState,
      resetState = _ref.resetState;

  var _useState = (0, _react.useState)((0, _utils.uniqueElementId)()),
      _useState2 = _slicedToArray(_useState, 1),
      elId = _useState2[0];

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "ChiaraBannersBuilder sbc-component"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card mb-4"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-header"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-outline-secondary btn-icon mr-3 ".concat(collapsed ? 'collapsed' : ''),
      type: "button",
      onClick: function onClick() {
        return updateState({
          collapsed: !collapsed
        });
      },
      "aria-expanded": "true",
      "aria-controls": "#".concat(elId, "-body, #").concat(elId, "-footer")
    },
    /*#__PURE__*/
    _react["default"].createElement("i", {
      className: "material-icons"
    }, "expand_more")), "Chiara Banners"),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-body collapse ".concat(!collapsed ? 'show' : ''),
      id: "".concat(elId, "-body")
    }, groups.map(function (group, i) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "mb-3",
          key: i
        },
        /*#__PURE__*/
        _react["default"].createElement(_Group["default"], group))
      );
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-footer collapse ".concat(!collapsed ? 'show' : ''),
      id: "".concat(elId, "-footer")
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-secondary mr-2",
      onClick: function onClick() {
        return resetState();
      }
    }, "Reset to default"))))
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    groups: (0, _selectors.getGroups)(state),
    collapsed: (0, _selectors.getState)(state).collapsed,
    exportedHTML: (0, _selectors.getState)(state).exportedHTML
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  exportCode: _actions.exportCode,
  updateState: _actions.updateState,
  resetState: _actions.resetState
})(ChiaraBannersBuilder);

exports["default"] = _default;